import React from 'react';
import LicensesTableActionButtons from '../shared/LicensesTableActionButtons';
import StyledTable from '../../../shared/components/StyledTable';

import { getFilterOptions, sortAssignedRows } from '../shared/services/tableService';

/**
 * @typedef {object} FreeLicensesTableProps
 * @property {Array<*>} [usersData]
 * @property {number} pageMode
 * @property {number} [orgId]
 * @property {string} [orgName]
 * @property {boolean} [singleUnit]
 * @property {boolean} [loading]
 * @property {(userId: number) => void} [openConfirmDialog]
 */

/**
 * @param {FreeLicensesTableProps} props
 */
const FreeLicensesTable = props => {
  const {
    usersData,
    pageMode,
    orgId,
    orgName,
    loading,
    openConfirmDialog,
    singleUnit = false
  } = props;

  const columns = [
    {
      title: 'Email',
      dataIndex: 'Email',
      sorter: (a, b) => sortAssignedRows(a.key, a.Email, b.Email),
      render: (text, _) => (!text ? '-' : text)
    },
    {
      title: 'Name',
      dataIndex: 'Name',
      sorter: (a, b) => sortAssignedRows(a.key, a.Name, b.Name),
      render: (text, _) => (!text ? '-' : text)
    },
    {
      title: 'Role',
      dataIndex: 'RoleDisplayName',
      filters: getFilterOptions(usersData, entry => entry.RoleDisplayName),
      onFilter: (value, record) => record.RoleDisplayName === value,
      render: (text, _) => (!text ? '-' : text)
    },
    {
      title: 'Unit',
      dataIndex: 'LicensedOrgUnit',
      sorter: (a, b) => a.LicensedOrgUnit.localeCompare(b.LicensedOrgUnit),
      filters: getFilterOptions(usersData, entry => entry.LicensedOrgUnit),
      onFilter: (value, record) => record.LicensedOrgUnit === value,
      hidden: !singleUnit
    },
    {
      title: 'Action',
      dataIndex: 'Actions',
      width: '10%',
      sorter: (a, b) => a.Actions - b.Actions,
      render: (_, record) => (
        <LicensesTableActionButtons
          pageMode={pageMode}
          orgId={orgId}
          orgName={orgName}
          userData={record}
          isFree={true}
          openConfirmDialog={openConfirmDialog}
        />
      )
    }
  ];

  const filteredColumns = columns.filter(item => !item.hidden);

  return (
    <div className='table-of-licenses'>
      <StyledTable
        columns={filteredColumns}
        dataSource={usersData}
        pagination={false}
        showSorterTooltip={false}
        loading={loading}
      />
    </div>
  );
};

export default FreeLicensesTable;
